import { request } from "../utils/request";
import store from "../store/index";

const systemclassification = {
  //获取历史选择的系统类型。
  gethostorysystem(data) {
    return request({
      method: "POST",
      url: "/api/userAuth/appManage/getsofthistory",
      data
    });
  },
  getsystem(data) {
    return request({
      method: "POST",
      url: "/api/userAuth/appManage/soft",
      data
    });
  },
  setsystem(data) {
    return request({
      method: "POST",
      url: "api/userAuth/appManage/addsofthistory",
      data
    });
  },
  //二级菜单埋点接口,获取分类
  getlistResources(data) {
    return request({
      method: "POST",
      url: "/api/point/buriedPointResource/listResources",
      data
    });
  },
  //二级菜单埋点接口,获取分类
  addburied(data) {
    return request({
      method: "POST",
      url: "/api/point/buriedPointResource/add",
      data
    });
  },
  //获取更新历史
  getRenewKhy(data) {
    return request({
      method: "POST",
      url: "api/information/getRenewKhy/getRenewKhy",
      data
    });
  },
  //
  updateKhyLoginIndex(data) {
    return request({
      method: "POST",
      url: "/api/user/login/updateKhyLoginIndex ",
      data
    });
  },
  // 成绩报告接口=========>
  examReport1(data) {
    return request({
      method: "POST",
      url: "api/examManage/examlist/examReport1",
      data
    });
  },
  // 第三个、
  examReport3(data) {
    return request({
      method: "POST",
      url: "api/examManage/examlist/examReport3",
      data
    });
  },
  // 第四个
  examReport4(data) {
    return request({
      method: "POST",
      url: "api/examManage/examlist/examReport4",
      data
    });
  },
  // 第五个
  examReport5(data) {
    return request({
      method: "POST",
      url: "api/examManage/examlist/examReport5",
      data
    });
  } ,
  // 第六个
  examReport6(data) {
    return request({
      method: "POST",
      url: "api/examManage/examlist/examReport6",
      data
    });
  },
  //获取更新历史
  noRenewKhy(data) {
    return request({
      method: "POST",
      url: "api/information/noRenewKhy/noRenewKhy",
      data
    });
  },
  // 查询用户医院到期时间及价格等信息
  timeCheck(data) {
    return request({
      method: "POST",
      url: "api/vip/renew/timeCheck",
      data
    });
  },
  // 下订单 
  createOrder(data) {
    return request({
      method: "POST",
      url: "api/vip/renew/createOrder",
      data
    });
  },
  // 查询订单是否付款
  orderCheck(data) {
    return request({
      method: "POST",
      url: "api/vip/renew/orderCheck",
      data
    });
  },
  // 删除数据备份列表
  getAllVideo(data) {
    return request({
      method: "POST",
      url: "api/courseware/VideoManage/getAllVideo",
      data
    });
  },
  // 变更科室职称列表 
  PTitleWaitList(data) {
    return request({
      method: "POST",
      url: "/api/ksgl/manageStudent/PTitleWaitList",
      data
    });
  },
  // 审批职称 
  updatePTitle(data) {
    return request({
      method: "POST",
      url: "/api/ksgl/manageStudent/updatePTitle",
      data
    });
  },
  // 获取人脸审核列表 
  getWaitList(data) {
    return request({
      method: "POST",
      url: "/api/faceAuth/faceAuthManager/getWaitList",
      data
    });
  },
  // 获取人脸图片
  getFaceImg(data) {
    return request({
      method: "POST",
      url: "/api/faceAuth/faceAuthManager/getFaceImg",
      data
    });
  },
  // 审批人脸信息
  updateFaceAuth(data) {
    return request({
      method: "POST",
      url: "/api/faceAuth/faceAuthManager/updateFaceAuth",
      data
    });
  },
  importUser2Group(data) {
    return request({
      method: "POST",
      url: "/api/ksgl/groupManage/importUser2Group",
      data
    });
  },
    // 组卷添加考生===》批量导入
    importExcelAndCreateExam(data) {
      return request({
        method: "POST",
        url: "/api/ksgl/manageStudent/importExcelAndCreateExam",
        data
      });
    },
};

export default systemclassification;
